import { useApi } from "../../../swr/useApi";
import { adminProductRequestsService } from "../../api_client";
import type { ProductRequestResponseDto, ProductRequestQueryDto } from "../../../api";
import { ProductRequestQueryDtoRequestStatusEnum } from "../../../api";

function useStatusCount(status: ProductRequestQueryDtoRequestStatusEnum) {
  return useApi<ProductRequestResponseDto>(
    `admin-product-review-stats-${status}`,
    () =>
      adminProductRequestsService.adminGetAllProductRequests(
        { page: 1, pageSize: 1, requestStatus: status } as ProductRequestQueryDto,
      ),
  );
}

export function useProductReviewStats() {
  const approved = useStatusCount(ProductRequestQueryDtoRequestStatusEnum.Approved);
  const pending = useStatusCount(ProductRequestQueryDtoRequestStatusEnum.Pending);
  const rejected = useStatusCount(ProductRequestQueryDtoRequestStatusEnum.Rejected);

  return {
    approved: approved.data?.meta?.totalCount,
    pending: pending.data?.meta?.totalCount,
    rejected: rejected.data?.meta?.totalCount,
    isLoading: approved.isLoading || pending.isLoading || rejected.isLoading,
  };
}
